import { FaustTemplate, useFaustQuery } from '@faustwp/core';

import { GetLayoutQuery, GetPageQuery } from '../../__generated__/graphql';
import { mapAcfBlockToContentBlock } from '../../content-blocks/mapContentBlocks';
import Layout from '../../layout';
import { gql } from '../helpers';
import GetLayout from '../layoutQuery.gql';
import GetPage from '../pageQuery.gql';

const Component: FaustTemplate<unknown> = props => {
  const homePageData = useFaustQuery<GetPageQuery | undefined>(GetPage);
  const layoutData = useFaustQuery<GetLayoutQuery | undefined>(GetLayout);

  if (!homePageData || !layoutData) {
    return <>Loading...</>;
  }

  return (
    <Layout
      isLoading={!!props.loading}
      layoutData={layoutData}
      pageData={homePageData}
      withBreadcrumbs
    >
      {({ acfFragments }) => acfFragments.map(mapAcfBlockToContentBlock('page', homePageData.page?.id ?? ''))}
    </Layout>
  );
};

Component.queries = [
  {
    query: gql(GetPage),
    variables: ({
      id: pageId,
    }, ctx) => {
      return {
        asPreview: ctx?.asPreview,
        pageId,
      };
    },
  },
  {
    query: gql(GetLayout),
  },
];

Component.variables = ({
  id: pageId,
}, ctx) => {
  return {
    asPreview: ctx?.asPreview,
    pageId,
  };
};

export default Component;
